import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from 'src/sb-tools/typescript/authentication/authentication.service';
import { HelperService } from '@sb-tools/typescript/services/helper.service';
import { environment } from '@environment';

@Injectable()
export class RedirectGuard implements CanActivate {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService, // private appInsightsService: AppInsightsService
    ) {}

    canActivate(): boolean {
        const hash = window.location.hash;

        if (hash && hash.indexOf('access_token') !== -1) {
            const facebookToken = HelperService.getValueFromHash(hash, 'access_token');
            const facebookCommunityName = HelperService.getValueFromHash(hash, 'state');
            window.location.href =
                environment.settingsUrl +
                facebookCommunityName +
                '/community/installation/facebook?access_token=' +
                facebookToken;

            return true;
        }

        if (this.authenticationService.community) {
            this.router.navigateByUrl('/' + this.authenticationService.community + '/tickets');
        } else {
            this.authenticationService.redirectToCommunities();
        }

        return false;
    }
}
